import { CheckIcon } from "@shared/ui/Icon/ui/history/check-icon";
import { WarnIcon } from "@shared/ui/Icon/ui/history/warn-icon";
import { ReportFinesProps } from "./types";
import classes from "./report-fines.module.scss";

export const ReportFines = ({ hasFines }: ReportFinesProps) => {
    return (
        <div className={classes.fines}>
            <div className={classes.fines__note}>
                <WarnIcon className={classes["fines__note--icon"]} />
                Ищем штрафы по номеру СТС в базе ГИБДД с 2015 года
            </div>
            <div className={classes.fines__result}>
                <CheckIcon className={classes["fines__result--icon"]} />{" "}
                {hasFines ? "Штрафы зафиксированы" : "В ГИБДД нет данных о штрафах"}
            </div>
        </div>
    );
};